import React from "react";
import ReactDOM from "react-dom";

const ModalPortal: React.FC = (props) => {
  const domNode = typeof document !== "undefined" ? document.getElementById("modal-root") : null;
  return domNode ? ReactDOM.createPortal(props.children, domNode) : null;
};

export default ModalPortal;
